import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

interface GetDashboardContactOverviewParam {
	client?: string
}
export type GetDashboardContactOverviewResponse = Array<{
	_id: {
		source: string
	}
	count: number
}>
const getDashboardContactOverview = async (
	params: GetDashboardContactOverviewParam
): Promise<GetDashboardContactOverviewResponse> => {
	try {
		const { data } = await axios.get('v1/management/contacts/insight/source', {
			params,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getDashboardContactOverview
